export class OrderTemplateType {
    id: number;
    code: string;
    name: string;
    comment: string;
    eolIncId: number;
    eolSqlId: number;
}

export enum FieldCriteria {
    Hidden = 0,
    Optional = 1,
    Mandatory = 2
}
